import { render, staticRenderFns } from "./blayer.vue?vue&type=template&id=8f9686a8&scoped=true"
import script from "./blayer.vue?vue&type=script&lang=js"
export * from "./blayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9686a8",
  null
  
)

export default component.exports